export const pipe = (...functions) => (arg) => {
  let ret = arg

  for (const func of functions) {
    ret = func(ret)
  }

  return ret
}
